import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { Link as RouterLink } from '~/lib/react-router-dom';

import { Box, Button, CircularProgress, Container, Paper, Stack, Typography } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';
import { BidAutomationRules } from '~/components/GoogleAds/BidAutomationRules';
import HoverNav from '~/components/GoogleAds/HoverNav';

import * as publicOfferFeedService from '~/services/PublicOfferFeedService';
import { AdCampaign } from '~/services/PublicOfferFeedService';

function CampaignDetailsView() {
  const { customerId, campaignId } = useParams<{ customerId: string; campaignId: string }>();
  const [campaign, setCampaign] = useState<AdCampaign | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const response = await publicOfferFeedService.getCustomers();
        const customer = response.result.find((c: any) => c.id === customerId);

        if (customer && Array.isArray(customer.campaigns)) {
          const matchedCampaign = customer.campaigns.find((c: AdCampaign) => c.id === campaignId);
          setCampaign(matchedCampaign);
        }
      } catch (error) {
        console.error('Failed to fetch campaign:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCampaign();
  }, [customerId, campaignId]);

  if (loading) {
    return (
      <Box p={2} display="flex" justifyContent="center">
        <CircularProgress variant="indeterminate" />
      </Box>
    );
  }

  if (!campaign) {
    return <Typography color="error">Campaign not found.</Typography>;
  }

  return (
    <Box className="offer-deal with-side-bar">
      <Box className="side-bar">
        <HoverNav />
      </Box>
      <Container>
        <PageSubheader title="Campaign Overview">
          <Box>
            <Typography variant="h6" fontSize={16} color="secondary" textTransform="uppercase">
              {campaign?.campaignBudget?.status}
            </Typography>
          </Box>
        </PageSubheader>
        <Paper sx={{ my: 4 }} id="overview" className="branded-panel">
          <Stack spacing={2}>
            <Typography variant="body1">
              <Typography fontWeight="bold" display="inline" component="span">
                Campaign Id :
              </Typography>{' '}
              {campaign.id}
            </Typography>
            <Typography variant="body1">
              <Typography fontWeight="bold" display="inline" component="span">
                Campaign Name :
              </Typography>{' '}
              {campaign?.name}
            </Typography>

            <Typography variant="body1">
              <Typography fontWeight="bold" display="inline" component="span">
                Budget :
              </Typography>{' '}
              ${Number(campaign.campaignBudget.amountMicros) / 1_000_000}
            </Typography>

            <Box mt={1}>
              <Button
                component={RouterLink}
                to={`/marketing/google-ads/customer/${customerId}/campaign/${campaignId}/ad-group`}
                variant="outlined"
                sx={{ mt: 2 }}
              >
                View Ad Groups
              </Button>
            </Box>
          </Stack>
        </Paper>
        <BidAutomationRules campaignId={campaignId} customerId={customerId} />
      </Container>
    </Box>
  );
}

export default CampaignDetailsView;
